// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import App from './App'
import router from './router'
import store from './store/store'
import Moment from 'vue-moment'
import VueResource from 'vue-resource'
import infiniteScroll from 'vue-infinite-scroll'
import Translations from './assets/translations/translations'
import Multiselect from 'vue-multiselect'
import SocialSharing from 'vue-social-sharing'

Vue.component('multiselect', Multiselect)
Vue.use(infiniteScroll)
Vue.use(BootstrapVue)
Vue.use(VueResource)

Vue.use(SocialSharing)
Vue.prototype.$translations = Translations

Vue.use(Moment)

Vue.mixin({
  methods: {
    setItalianLanguage () {
      this.$router.push(this.getCurrentPage() + '/italian')
      this.$store.commit('setCurrentLanguage', 'Italian')
    },
    setEnglishLanguage () {
      this.$router.push(this.getCurrentPage() + '/english')
      this.$store.commit('setCurrentLanguage', 'English')
    },
    setGermanLanguage () {
      this.$router.push(this.getCurrentPage() + '/german')
      this.$store.commit('setCurrentLanguage', 'German')
    },
    setFrenchLanguage () {
      this.$router.push(this.getCurrentPage() + '/french')
      this.$store.commit('setCurrentLanguage', 'French')
    },
    setSlovenianLanguage () {
      this.$router.push(this.getCurrentPage() + '/slovenian')
      this.$store.commit('setCurrentLanguage', 'Slovenian')
    },
    getCurrentPage () {
      switch (this.$store.getters.currentViewValue.name) {
        case 'HomePage':
          return '/home'
        case 'EventsPage':
          return '/events'
        case 'SocialWallPage':
          return '/social-wall'
        case 'ContestPage':
          return '/contest'
        case 'NewsPage':
          return '/news'
        case 'SupportersPage':
          return '/supporters'
        case 'SignPetitionPage':
          return '/sign-petition'
        case 'PaperPage':
          return '/paper'
        case 'VideosPage':
          return '/videos-gallery'
        case 'InventoryMapPage':
          return '/inventory-map'
        default:
          return '/home'
      }
    }
  }
})
Vue.config.productionTip = false

Vue.prototype.$PATH_NAME = process.env.API_URL || 'https://localhost:8080/'
// Vue.prototype.$PATH_NAME = 'https://api.alpfoodway.eu/'

// console.log('Using API at ' + Vue.prototype.$PATH_NAME)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js